import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=55132cfb&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55132cfb')) {
      api.createRecord('55132cfb', component.options)
    } else {
      api.reload('55132cfb', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=55132cfb&", function () {
      api.rerender('55132cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4v7EtJXvl4QHn/JS/comp/FavElement.vue"
export default component.exports